module.exports = __webpack_public_path__ + "static/media/paint9.8fadee6a.jpg";